import Pagination from '@/util/pagination'

export default function () {
  return {
    filters: {
      name: '',
      email: '',
    },
    users: [],
    pagination: new Pagination(),
    videoPlaying: {},
    showVideoDialog: false,
  }
}
